
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>

     <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >

      <b-card title="Informations générales">
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                placeholder="Nom du produit"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          
          <b-col
        
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Couleur"
              label-for="Couleur"
            >
            <v-select
              v-model="form.color"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              
              :closeOnSelect="false"
              label="title"
              :options="colorChoices"
            >

            <template slot="option" slot-scope="option">
                  <img :src="option.cardImage" width='15' />
                  {{ option.title }}
                </template>

                </v-select>
            
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Ordre d'affichage"
              label-for="Ordre d'affichage"
            >
           
            
              <b-form-input
                id="Ordre d'affichage"
                v-model="form.order_display"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Ordre d'affichage"
               
              />
             
            </b-form-group>
          </b-col>

          <b-col
          
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Teinte"
              label-for="Teinte"
            >
            <v-select
              v-model="form.tint"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :closeOnSelect="false"
              label="title"
              :options="tintChoices"
            >
            <template slot="option" slot-scope="option">
                  <img :src="option.cardImage" width='15' />
                  {{ option.title }}
                </template>
                </v-select>
            
            </b-form-group>
          </b-col>


        </b-row>

        <b-row>
          <b-col
            md="12"
            class="mb-1"
          >
            <b-form-group
              label="Photos"
              label-for="photos"
            >
              <draggable
                v-model="photos"
                group="glass_variation_photos"
                @start="drag=true"
                @end="drag=false"
              >
                <b-card
                  v-for="(photo, index) in photos"
                  :key="`photo-${index}`"
                  class="mb-1"
                >
                  <b-row>
                    <b-col
                      md="3"
                      class="d-flex align-items-center mb-1 mb-md-0"
                    >
                      <b-media vertical-align="top">
                        <template #aside>
                          <b-img
                            v-if="photo"
                            :src="photo"
                            blank-color="#ccc"
                            width="64"
                            alt="photo"
                          />
                          <div
                            v-else
                            class="d-flex align-items-center justify-content-center border rounded"
                            style="width:64px; height:64px;"
                          >
                            <small class="text-muted">Apercu</small>
                          </div>
                        </template>
                      </b-media>
                    </b-col>

                    

                    <b-col
                      md="2"
                      class="d-flex align-items-center justify-content-md-end"
                    >
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        size="sm"
                        variant="outline-danger"
                        class="btn-icon"
                        @click="removePhoto(index)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col md="12">
                      <b-form-file
                        v-model="photoFiles[index]"
                        :state="Boolean(photoFiles[index])"
                        placeholder="Choisissez ou faites glisser un fichier..."
                        drop-placeholder="Deposer ici ..."
                        @change="fileAddedPhoto($event, index)"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </draggable>

              <a @click="addPhoto()">Ajouter une photo</a>
            </b-form-group>
          </b-col>
        </b-row>

        
  
      </b-card>

    


   </b-form>

  </validation-observer>



  <b-button v-if="edition==false"
     @click.prevent="createModelPart"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click.prevent="updateModelPart"
    >
    Enregistrer
    </b-button>
  </div>

  </b-overlay>
</template>

<script>
import { BButton,BFormInput, BRow, BForm, BCol,BOverlay, BFormGroup,BFormFile, BCard, BCardText, BMedia, BImg, BFormCheckbox, BFormTextarea, BSpinner} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'


export default {
  name: 'GlassVariationForm',
  components: {
    BButton,
    BCardText,
    BMedia, 
    BOverlay,
    BImg,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BSpinner,
    draggable,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          loading:true,
       
          edition:false,
          loaded:false,
          drag:false,
          glass_variation_id:null,
          glass:null,
          currentBase64:null,
          plastic_colors:[],
          metal_colors:[],
          
          colors:[],
          tints:[],
         
          colorChoices:[],
          tintChoices:[],
         
         
        
          initialForm:{
            name:"",
            order_display:0,
            glass:null,
            color:null,
            tint:null,
            photos:[],
          
          },
          form:{
            name:"",
            order_display:0,
            glass:null,
            color:null,
            tint:null,
            photos:[],
          },
          photos:[''],
          photoFiles:[null],
          
      }
  },
  computed: {
    
  },
  filters: {
      
  },
  
  watch:{
    
  },
 
  props: [
    'glass_id', 
    'readOnly', 
    'glass_variation',
   
    ],
  methods:{
      normalizePhotos(rawPhotos) {
        if (!rawPhotos) {
          return ['']
        }

        if (Array.isArray(rawPhotos)) {
          const cleaned = rawPhotos.filter(photo => photo !== null && photo !== undefined && `${photo}`.trim() !== '')
          return cleaned.length > 0 ? cleaned : ['']
        }

        if (typeof rawPhotos === 'string') {
          const trimmed = rawPhotos.trim()
          if (trimmed === '') {
            return ['']
          }

          try {
            const parsed = JSON.parse(trimmed)
            if (Array.isArray(parsed)) {
              const cleaned = parsed.filter(photo => photo !== null && photo !== undefined && `${photo}`.trim() !== '')
              return cleaned.length > 0 ? cleaned : ['']
            }
          } catch (e) {
            const withoutBrackets = trimmed.replace(/^\[/, '').replace(/\]$/, '')
            const values = withoutBrackets
              .split(']')
              .map(value => value.trim().replace(/^['"]/, '').replace(/['"]$/, '').replace('[', '').replace(']', '').replace("'", ''))
              .filter(value => value !== '')

            return values.length > 0 ? values : ['']
          }
        }

        return ['']
      },
      buildPhotosPayload() {

        let photos_text="["
        for(let i=0;i<this.photos.length;i++)
        {
          photos_text+='"'+this.photos[i]+'"/!/'
        }
        photos_text=photos_text.slice(0,-3)
        photos_text+=']'
        return photos_text
       
      },
      addPhoto() {
        this.photos.push('')
        this.photoFiles.push(null)
      },
      removePhoto(index) {
        this.photos.splice(index, 1)
        this.photoFiles.splice(index, 1)

        if (this.photos.length === 0) {
          this.photos = ['']
          this.photoFiles = [null]
        }
      },
      fileAddedPhoto(event, index) {
        if (!event || !event.target || !event.target.files || !event.target.files[0]) {
          return
        }

        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          const raw = `${reader.result || ''}`
          const b64 = raw.split(';')
          const type = b64[0] || ''

          if (type.includes('image') || type.includes('video') || type.includes('mp4')) {
            this.currentBase64 = raw
            this.photos[index] = raw
            return
          }

          this.photoFiles[index] = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Ce fichier n'est pas une image/video !",
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
        }
      },
   
     
      formatSelect(item) {
        
        if(item=='colors')
        {
          
          if(this.glass_variation.color!=null)
          {
          for(let i=0;i<this.colorChoices.length;i++)
          {
            if(this.glass_variation.color.id == this.colorChoices[i].value)
            {
              this.form.color=this.colorChoices[i]
            }
          }
        }
          
        }
        
        if(item=='tints')
        {
          
         if(this.glass_variation.tint!=null)
         {
          for(let i=0;i<this.tintChoices.length;i++)
          {
            if(this.glass_variation.tint.id == this.tintChoices[i].value)
            {
              this.form.tint=this.tintChoices[i]
            }
          }
          }
        }
        
      },
    
      
      async getTints() {
        let tints = await APIRequest.list('tints')
        this.tints=tints[0];
       
        

        let new_tintChoices=[]

        for(let i=0;i<this.tints.length;i++)
        {
          new_tintChoices.push({value:this.tints[i].id,title:this.tints[i].name+' (cat '+this.tints[i].category+')',cardImage:this.tints[i].photo})
        }
        this.tintChoices=new_tintChoices
       if(this.glass_variation!=null)
       {
        this.formatSelect('tints')
       }
        

        
      },
      async getColors() {
        
        let colors = await APIRequest.list('colors')
        this.colors=colors[0];
        this.colorChoices=Utils.formatSelectWithImg(this.colors,'name','id','photo')

       
       if(this.glass_variation!=null)
       {
        this.formatSelect('colors')
       }
        
        
      },
     
      
      async createModelPart()
      {
        this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loading=true
         
          const datas={...this.form}
      
          try {
            
              datas.color={id:datas.color.value}
              datas.tint={id:datas.tint.value}
              datas.photos=this.buildPhotosPayload()
             
            
            let glass_variation = await APIRequest.create('glass-variations',datas)
            console.log('glass variation cree')
            console.log(glass_variation)





            this.glass_variation_id=glass_variation.id
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'La variation a bien été créée !',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
           this.$router.push({name:'editGlass', params: { id: this.glass_id }})
          } catch (error) {
            this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
        }
        })
      },
      async updateModelPart()
      {
         this.$refs.simpleRules.validate().then(async success => {
        if (success) {

          
          this.loading=true
          
          const datas={...this.form}
          
          try {
            datas.color={id:datas.color.value}
            datas.tint={id:datas.tint.value}
            datas.photos=this.buildPhotosPayload()
            


          


          let glass_variation = await APIRequest.update('glass-variations',this.glass_variation.id,datas)
          
            

          this.glass_variation_id=glass_variation.id

          

          
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'La variation a bien été modifiée !',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push({name:'editGlass', params: { id: this.glass_id }})
          } catch (error) {
            console.log("error")
            console.log(error)
            this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
        }
         })
      },
      

      
      
  },
  async mounted(){

   
 
 
    
    

    this.glass=await APIRequest.detail('glasses',this.glass_id)

    if(this.glass_variation!=null)
    {

     
      this.form={...this.glass_variation}
      this.photos=this.normalizePhotos(this.glass_variation.photos)
      this.photoFiles=Array(this.photos.length).fill(null)
      
  
      this.edition=true
      
    }
    else
    {
      this.photos=['']
      this.photoFiles=[null]
    }
    this.form.glass={id:this.glass_id}
    await this.getTints()
    await this.getColors()

    
    this.loaded=true
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>